 import {IWebsiteState} from "../reducers/website.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {Website} from "../../websites/website/website";
import {DbStoreState} from "../reducers";
import {WebsiteMapper} from "../../websites/website/website-mapper";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getWebsiteState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.website);

export const getWebsites = createSelector(getWebsiteState,
  (state: IWebsiteState): Website[] => {
    const websiteMap: Website[] = Object.values(state.entities).reduce((websiteMapData: any, website: Website) => {
      websiteMapData[website.id] = WebsiteMapper.map(website, Object.values(state.entities));
      return websiteMapData;
    }, {});
    return Object.values(websiteMap).filter((website: any) => typeof website.site_url !== "undefined" && website.connectedFrom !== 'ai_assistant'); }
);


export const getAllWebsites = createSelector(getWebsiteState,
  (state: IWebsiteState): Website[] => {
    const websiteMap: Website[] = Object.values(state.entities).reduce((websiteMapData: any, website: Website) => {
      websiteMapData[website.id] = WebsiteMapper.map(website, Object.values(state.entities));
      return websiteMapData;
    }, {});
    return Object.values(websiteMap).filter((website: any) => typeof website.site_url !== "undefined"); }
);

export const getStoppedWebsites = createSelector(getWebsiteState,
  (state: IWebsiteState) => {
    const websiteMap = Object.values(state.entities).reduce((websiteMapData: any, website: Website) => {
      websiteMapData[website.id] = WebsiteMapper.map(website, Object.values(state.entities));
      return websiteMapData;
    }, {});
    return Object.values(websiteMap).filter((website: any) => typeof website.site_url !== "undefined" && website.isStopped && website.connectedFrom !== 'ai_assistant'); }
);

export const getActiveConnectedWebsites = createSelector(getWebsiteState,
  (state: IWebsiteState) => {
    return Object.values(state.entities)
      .map((website: Website) => {
        return WebsiteMapper.map(website, Object.values(state.entities));
      }, [])
      .filter((website: Website) => !website.parentId && website.isActive && !website.isLocalhost && !website.isMigrated && !website.domain_hash && website.connectedFrom !== 'ai_assistant');
  }
);

export const getConnectedWebsites = createSelector(getWebsiteState,
  (state: IWebsiteState) => {
    return Object.values(state.entities)
      .map((website: Website) => {
        return WebsiteMapper.map(website, Object.values(state.entities));
      }, [])
      .filter((website: Website) => !website.parentId && !website.isMigrated
        && !website.domain_hash && website.connectedFrom !== 'ai_assistant');
  }
);

export const getHostedWebsites = createSelector(getWebsiteState,
  (state: IWebsiteState) => {
    return Object.values(state.entities)
      .map((website: Website) => {
        return WebsiteMapper.map(website, Object.values(state.entities));
      }, [])
      .filter((website: Website) => website.isActive && !website.isLocalhost && website.domain_hash && !website.isStopped);
  }
);

export const getWebsitesMap = createSelector(getWebsiteState,
  (state: IWebsiteState) => {
    const websiteMap = Object.values(state.entities).reduce((websiteMapData: any, website: Website) => {
      websiteMapData[website.id] = WebsiteMapper.map(website, Object.values(state.entities));
      return websiteMapData;
    }, {});
    return websiteMap; }
);

export const getWebsite = (websiteId: number) => createSelector(getWebsiteState,
  (state: IWebsiteState) => state.entities[websiteId] ? WebsiteMapper.map(state.entities[websiteId], Object.values(state.entities)) : null
);

export const getWebsitesLoading = createSelector(getWebsiteState,
  (state: IWebsiteState) =>
    state.loading
);

export const getWebsitesLoaded = createSelector(getWebsiteState,
  (state: IWebsiteState) =>
    state.loaded
);
